import { initStore, PLAYERS_SEARCH_TYPES } from '../../../common';
import { actions } from './actions';

export const playerListStore = (): void => {
	const initialState = {
		slice: 'PLAYER_LIST',
		players: [],
		playersLoading: false,
		partners: [],
		player_levels: [],
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		perPage: '10',
		columns: [],
		initialColumns: [],
		filtering: false,
		filters: [{ name: 'searchType', value: PLAYERS_SEARCH_TYPES[0].value }],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
